// src/components/PrivateRoute.js
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = () => {
  const { isAuthenticated, loading: authLoading, user } = useAuth();
  const location = useLocation();

  if (authLoading) {
    return (
      <div className="min-h-screen bg-theme-bg flex flex-col items-center justify-center animate-fade-in p-8">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-chafadi-primary/20 border-t-chafadi-primary rounded-full animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 bg-chafadi-primary rounded-full animate-ping" />
          </div>
        </div>
        <div className="mt-8 space-y-2 text-center">
          <p className="text-xs font-black text-theme-text uppercase tracking-[0.4em] animate-pulse">Establishing Secure Session</p>
          <p className="text-[10px] font-medium text-theme-muted uppercase tracking-widest">Verifying credentials with Chafadi Core</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    user?.is_first_login &&
    location.pathname !== "/onboarding" &&
    location.pathname !== "/verify-otp"
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
